/** One-shot: auto-open mobile rail only on cold landing on welcome (no last app). */
let shouldAutoOpenWelcomeSidebar = false;

export function markWelcomeSidebarAutoOpen(): void {
	shouldAutoOpenWelcomeSidebar = true;
}

export function consumeWelcomeSidebarAutoOpen(): boolean {
	const value = shouldAutoOpenWelcomeSidebar;
	shouldAutoOpenWelcomeSidebar = false;
	return value;
}
